import { DataBean } from "../DataBean";

export class TransportGuide extends DataBean {



    public async deleteTransportGuide(idAccountSupplier: any, transportGuideDate: any, invoiceID: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTransportGuide_Number_java.util.Date_String", [idAccountSupplier, transportGuideDate, invoiceID]);
    }

    public async getTransportGuideCatalog(year: any, month: any, idCargoManifest: any, idAccountCustomer: any, idAccountSupplier: any, idAgency: any, idTransportRoute: any, idTransportService: any, state: any, idAccountantConcept: any, idTransportGuide: any, consecutive: number, transportGuideCode: any, idLnSiteID: any, transportGuideDocType: any, idFreightType: any, idSalesConsultant: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore",
            "com.advantage.shared.Report_getTransportGuideCatalog_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_String_Number_Number_Number_Number_Number_Number",
            [year, month, idCargoManifest, idAccountCustomer, idAccountSupplier, idAgency, idTransportRoute, idTransportService, state, idAccountantConcept, idTransportGuide, consecutive, transportGuideCode, idLnSiteID, transportGuideDocType, idFreightType, idSalesConsultant, page, recordsPerPage]);
    }

    public async updateTransportGuide(bean: any): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.transportguides.TransportGuide_updateTransportGuide_com.quickdataerp.bean.transportguides.TransportGuide",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.quickdataerp.bean.transportguides.TransportGuide"
                }
            ]
        );
    }

    public async sendTransportGuide(idTransportGuide: any, transportGuideDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_sendTransportGuide_Number_java.util.Date_Number", [idTransportGuide, transportGuideDate, idEmployee]);
    }

    public async liquidateTransportGuide(idTransportGuide: any, transportGuideDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.TransportGuide_liquidateTransportGuide_Number_java.util.Date_Number", [idTransportGuide, transportGuideDate, idEmployee]);
    }
}